import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-trip-update-card',
    templateUrl: './trip-update-card.component.html',
    styleUrls: ['./trip-update-card.component.scss'],
    standalone: false
})
export class TripUpdateCardComponent implements OnInit {

  @Input() changeInfo: any = {};
  constructor() { }

  ngOnInit() {
  }

}
